/* eslint-disable yola/import/no-extraneous-dependencies */
import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducer from 'src/js/reducer';
import middleware from 'src/js/middleware';

const store = createStore(reducer(), composeWithDevTools(applyMiddleware(...middleware)));

export default store;
